export var create = function create() {
  return new Set();
};
/**
 * @template T
 * @param {Set<T>} set
 * @return {Array<T>}
 */

export var toArray = function toArray(set) {
  return Array.from(set);
};